'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reduxAsyncConnect = require('redux-async-connect');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

var _reactChartjs = require('react-chartjs');

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _components = require('../../components');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _FundCleanEnergyInvestments = require('./FundCleanEnergyInvestments.css');

var _FundCleanEnergyInvestments2 = _interopRequireDefault(_FundCleanEnergyInvestments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FirstPage = 5;
var AllPage = 1000000;

var ScaleStart = '#00a6d0';
var ScaleEnd = '#00a6d0';

function mapFundHoldings(fHoldings) {
  var fHoldingsMap = {};
  fHoldings.forEach(function (fholding) {
    fHoldingsMap[fholding.db_holding_id] = fholding;
  });
  return fHoldingsMap;
}

function filterHoldings(fHoldingsMap, holdings, filterFn) {
  return (0, _lodash.chain)(holdings).filter(filterFn).sortBy(function (o) {
    return fHoldingsMap[o.id].market_value * -1;
  })
  // .take(10)
  .value();
}

var pieChartOptions = {
  animation: false,
  segmentStrokeWidth: 0,
  percentageInnerCutout: 70,
  // animationEasing: 'easeOutQuad',
  // String - Template string for single tooltips
  // tooltipTemplate: "<%if (label){%><%=label %>: $<%}%><%= value + ' M' %>",
  tooltipTemplate: '<%=label %>',
  // String - Template string for multiple tooltips
  multiTooltipTemplate: "<%= value + ' %' %>"
};

var barChartOptions = {
  animation: false,
  responsive: true,
  scaleShowLabels: true,
  scaleShowGridLines: true,
  scaleShowVerticalLines: false,
  scaleShowHorizontalLines: true,
  showScale: true,
  scaleStartValue: 0,
  // String - Template string for single tooltips
  tooltipTemplate: "<%if (label){%><%=label %>: <%}%><%= value + ' %' %>",
  // String - Template string for multiple tooltips
  multiTooltipTemplate: "<%= value + ' %' %>"
};

var FundCleanEnergyInvestments = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  };
}, searchActions), _dec2 = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true, // need otherwise cient navigate is blocked until the page is loaded
  promise: function promise(_ref) {
    var params = _ref.params,
        _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId));
  }
}]), _dec3 = (0, _reactCssModules2.default)(_FundCleanEnergyInvestments2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundCleanEnergyInvestments, _Component);

  function FundCleanEnergyInvestments(props) {
    (0, _classCallCheck3.default)(this, FundCleanEnergyInvestments);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FundCleanEnergyInvestments.__proto__ || (0, _getPrototypeOf2.default)(FundCleanEnergyInvestments)).call(this, props));

    _this.getPieChartData = function (invested, fHoldingsMap, holdings) {
      // if no holdings, return data for a plain gray donut
      if (holdings.length === 0) {
        return [{
          value: 1,
          label: 'No Clean200 Stock Holdings',
          color: '#D5D5D5'
        }];
      }

      // build a color scale based on how many holdings there are
      var num_colors = holdings.length;
      var f = _chromaJs2.default.scale([ScaleStart, ScaleEnd]).mode('rgb').colors(num_colors);
      var currIdx = -1;

      // format holdings as pie chart data
      var pieChartHoldings = holdings.map(function (holding) {
        var nameLabel = _format2.default.longString(holding.security_name, 15);
        var moneyLabel = _format2.default.money(fHoldingsMap[holding.id].market_value, true, 'USD', true);
        // increment the counter for the color index
        currIdx = (currIdx + 1) % num_colors;

        return {
          value: fHoldingsMap[holding.id].market_value,
          label: nameLabel + ' ' + moneyLabel,
          color: f[currIdx]
        };
      });

      return pieChartHoldings;
    };

    _this.getBarChartData = function (clean200, fossil) {
      var solids = ['#00a6d0', '#333333'];

      return {
        labels: ['Clean200', 'Carbon Underground 200'],
        datasets: [{
          label: 'Amount invested',
          fillColor: solids,
          strokeColor: solids,
          highlightFill: solids,
          highlightStroke: solids,
          data: [clean200, fossil]
        }]
      };
    };

    _this.scrollTo = function (id) {
      return function () {
        var ele = document.getElementById(id);
        window.scrollTo(ele.offsetLeft, ele.offsetTop);
      };
    };

    _this.increment = function (incState) {
      return function () {
        var newState = {};
        newState[incState] = _this.state[incState] + 1;
        _this.setState(newState);
      };
    };

    _this.holdingsCount = function (count) {
      if (count === 1) {
        return _format2.default.number(count) + ' holding';
      } else if (count > 0) {
        return _format2.default.number(count) + ' holdings';
      }
      return '';
    };

    _this.renderHoldings = function (shareClass, fHoldingsMap, holdings, page) {
      if (!holdings || holdings.length === 0) {
        return _react2.default.createElement(
          'div',
          { styleName: 'holdings-none' },
          'None'
        );
      }

      var takeCount = page > 1 ? AllPage : FirstPage;

      return (0, _lodash.chain)(holdings).take(takeCount).map(function (h, idx) {
        return _react2.default.createElement(
          'li',
          { key: idx, styleName: 'holding' },
          _react2.default.createElement(
            'div',
            { styleName: 'holding-name' },
            _react2.default.createElement(
              'div',
              null,
              idx + 1,
              '. ',
              h.security_name
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-asset' },
            _format2.default.sectorLabel(h.sector)
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-asset' },
            _format2.default.perc(fHoldingsMap[h.id].long_weight),
            ' of assets'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-invested' },
            _format2.default.money(fHoldingsMap[h.id].market_value, true, shareClass.currency, true),
            ' invested'
          )
        );
      }).value();
    };

    _this.renderCompanies = function (shareClass, fHoldingsMap, type, label, _count, holdings, page) {
      var iconClean200Inactive = require('../../../static/images/clean-200-icon-inactive.png');
      var iconClean200 = require('../../../static/images/clean-200-icon.png');

      var count = _convert2.default.int(_count);

      var hasMoreButton = page === 1 && count > FirstPage ? _react2.default.createElement(
        'div',
        { styleName: 'detail-more-' + type,
          onClick: _this.increment(type + 'Page') },
        'See all'
      ) : null;

      if (count === 0) {
        return _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 12, styleName: 'detail-holdings-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'detail-wrapper-empty-clean' },
            _react2.default.createElement('img', { styleName: 'detail-icon-empty', src: iconClean200Inactive,
              alt: '0 holdings' }),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-title-empty' },
              label
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-holdings-empty' },
              '0 holdings'
            )
          )
        );
      }

      return _react2.default.createElement(
        _reactFlexboxGrid.Col,
        { xs: 12, styleName: 'detail-holdings-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'detail-' + type },
          _react2.default.createElement('img', { styleName: 'detail-icon', src: iconClean200, alt: label }),
          _react2.default.createElement(
            'div',
            { styleName: 'detail-title-holdings' },
            _react2.default.createElement(
              'div',
              { styleName: 'detail-title-' + type },
              label
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'visible-sm visible-md visible-lg detail-holdings-count-' + type },
              _this.holdingsCount(count)
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'visible-xs mobile-holdings-label' },
            _this.holdingsCount(count)
          ),
          _react2.default.createElement(
            'ul',
            { styleName: 'detail-holdings' },
            _this.renderHoldings(shareClass, fHoldingsMap, holdings, page)
          )
        ),
        hasMoreButton
      );
    };

    _this.renderMoreLessHeadline = function (cl_asset, c2asset) {
      var cl_fossil_more_less = '';
      if (cl_asset > c2asset) {
        cl_fossil_more_less = 'more';
      } else if (cl_asset < c2asset) {
        cl_fossil_more_less = 'less';
      } else if (cl_asset === c2asset) {
        cl_fossil_more_less = 'same';
      }

      var line = '';
      if (cl_fossil_more_less === 'more') {
        line = 'More investments in Clean200 than Carbon Underground 200';
      } else if (cl_fossil_more_less === 'less') {
        line = 'More investments in Carbon Underground 200 than Clean200';
      } else if (cl_fossil_more_less === 'same' && cl_asset === 0) {
        line = 'No stock investments in Clean200 or Carbon Underground 200';
      } else if (cl_fossil_more_less === 'meh' && cl_asset > 0) {
        line = 'Same invested in Clean200 as Carbon Underground 200';
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'clean200-subtitle' },
        'This fund has:',
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'span',
          { styleName: 'clean200-subtitle-' + cl_fossil_more_less },
          line
        )
      );
    };

    _this.state = {
      clean200Page: 1
    };
    return _this;
  }

  (0, _createClass3.default)(FundCleanEnergyInvestments, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _analytics2.default.event(_analytics2.default.eventLoadFund(this.props.params.fundId, this.props.params.investmentVehicleId));
    }

    // need this solution since asyncConnect and anchor links does not play nice

  }, {
    key: 'render',
    value: function render() {
      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
        );
      } else if (this.props.result && (!this.props.result.fund || !this.props.result.shareClass)) {
        this.context.router.push(_config2.default.routes.notFound);
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
        );
      }

      function getPerc(asset, totalAsset) {
        asset = _convert2.default.int(asset);
        totalAsset = _convert2.default.int(totalAsset);

        if (totalAsset === 0) {
          return 0;
        }

        return parseFloat((asset / totalAsset * 100).toFixed(2));
      }

      var _props$result = this.props.result,
          fund = _props$result.fund,
          shareClass = _props$result.shareClass;
      var holdings = fund.holdings,
          fundholdings = fund.fundholdings;

      var title = shareClass.fund_legal_name + ' | Clean200 investments';
      var url = _config2.default.domain + this.props.location.pathname;

      var invested = fund.cl_asset;
      var currency = 'USD';
      var percClean200 = getPerc(fund.cl_asset, fund.fund_net_assets);
      var percFossil = getPerc(fund.c2asset, fund.fund_net_assets);

      var cl_asset = _convert2.default.int(fund.cl_asset);
      var c2asset = _convert2.default.int(fund.c2asset);

      var fHoldingsMap = mapFundHoldings(fundholdings);
      var clean200Holdings = filterHoldings(fHoldingsMap, holdings, function (o) {
        return o.is_cl;
      });

      var pieChartData = this.getPieChartData(invested, fHoldingsMap, clean200Holdings);
      var barChartData = this.getBarChartData(percClean200, percFossil);

      var ckLogo = require('../../../static/images/corporate-knights-logo.png');
      var aysLogo = require('../../../static/images/asyousow.png');
      var windImg = require('../../../static/images/windmill.png');
      var solarImg = require('../../../static/images/solar.png');

      var _ticker = shareClass.ticker || null;
      var fundName = '' + fund.fund_legal_name;
      fundName = _ticker ? fundName + ' ' + _ticker : fundName;
      var clAsset = _convert2.default.int(fund.cl_asset);
      var clWeight = _convert2.default.float(fund.cl_weight);
      var _clAsset = _format2.default.money(clAsset, true, 'USD', false);
      var _clWeight = _format2.default.perc(clWeight);
      var description = fundName + ' has ' + _clAsset + ' invested in Clean200 companies, ' + _clWeight + ' of the fund';

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'fossil-fuel-banner-wrap' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h2',
              { styleName: 'fossil-fuel-banner-hl' },
              _react2.default.createElement(
                'span',
                { styleName: 'fossil-fuel-banner-hl-lg' },
                'Clean200'
              ),
              _react2.default.createElement(
                'span',
                { styleName: 'fossil-fuel-banner-hl-sm' },
                '200 companies leading on clean energy.'
              )
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.FundMenu, {
          active: 'Clean200',
          fundId: shareClass.fund_id,
          investmentVehicleId: shareClass.investment_vehicle_id,
          name: shareClass.fund_legal_name,
          ticker: shareClass.ticker
        }),
        _react2.default.createElement(_components.FundName, {
          shareClass: shareClass,
          pathname: this.props.location.pathname
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(
            'div',
            { styleName: 'clean200' },
            _react2.default.createElement(
              'div',
              { styleName: 'clean200-inner' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, sm: 12, md: 4, styleName: 'chart-sidebar-wrap' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'chart' },
                    _react2.default.createElement(_reactChartjs.Doughnut, { data: pieChartData, options: pieChartOptions,
                      width: '300', height: '300' }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'clean200-chart-details' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'clean200-chart-assets' },
                        _format2.default.money(_convert2.default.int(invested), true, currency)
                      ),
                      _react2.default.createElement(
                        'div',
                        null,
                        'invested in Clean200 stocks'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'clean200-stats' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'stat', 'data-multiline': true,
                        'data-effect': 'solid', 'data-for': 'clean200-tooltip',
                        'data-tip': 'Total number of Clean200<br/> stock holdings found in this fund' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'stat-count-wrapper' },
                        _react2.default.createElement(
                          'div',
                          { styleName: 'stat-count' },
                          fund.cl_count
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'stat-label' },
                        'Clean200 ',
                        _convert2.default.int(fund.cl_count) === 1 ? 'holding' : 'holdings'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'stat', 'data-multiline': true,
                        'data-effect': 'solid', 'data-for': 'clean200-tooltip',
                        'data-tip': 'Total percent of the fund\'s assets<br/>invested in Clean200 stocks' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'stat-count-wrapper' },
                        _react2.default.createElement(
                          'div',
                          { styleName: 'stat-count' },
                          percClean200,
                          '%'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'stat-label' },
                        ' of assests invested'
                      )
                    )
                  ),
                  _react2.default.createElement(_reactTooltip2.default, { id: 'clean200-tooltip' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'ck-logo-wrap' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'ck-label' },
                      'Clean200 was created by As\xA0You\xA0Sow and Corporate\xA0Knights'
                    ),
                    _react2.default.createElement('img', { styleName: 'ck-ays-logo', src: aysLogo,
                      alt: 'As You Sow' }),
                    _react2.default.createElement('img', { styleName: 'ck-logo', src: ckLogo,
                      alt: 'Corporate Knights' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'renewable-img-wrap' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'renewable-img-cell' },
                      _react2.default.createElement('img', { styleName: 'renewable-img-wind', src: windImg,
                        alt: 'Wind energy' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'renewable-img-cell' },
                      _react2.default.createElement('img', { styleName: 'renewable-img-solar', src: solarImg,
                        alt: 'Solar energy' })
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, sm: 12, md: 8, styleName: 'main-content-wrap' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'clean200-info' },
                    'The Clean200 is a list of 200 publicly traded companies that are leading the way with solutions for the transition to clean energy. ',
                    _react2.default.createElement(
                      _components.Link,
                      { xstrong: true, to: _config2.default.links.clean200, title: 'Carbon Clean 200 - As You Sow' },
                      'See the full list',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  /* render the list of Clean200 holdings */
                  this.renderCompanies(shareClass, fHoldingsMap, 'clean200', 'Clean200 holdings', shareClass.cl_count, clean200Holdings, this.state.clean200Page),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'clean200-info-large' },
                    'Methodology'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'clean200-info-small' },
                    'The Clean200 are the largest 200 public companies ranked by green energy revenues. The dataset is developed by multiplying a company\u2019s most recent year-end revenues by its clean revenue estimate, primarily sourced from Corporate Knights Research supplemented by FactSet, Bloomberg BNEF, and FTSE Russell data. In order to be eligible, a company must have USD revenue of at least $1 billion (most recent available fiscal year-end data) and earn more than 10% of total revenues from clean sources, which extends beyond energy efficiency, green energy, and zero emission and hybrid vehicles. We include banks that are financing the low-carbon solutions; real estate companies leading the way on low-carbon buildings; forestry companies protecting carbon sinks; responsible miners of critical materials for the low carbon economy; food and apparel companies with products that are primarily made of raw materials with a significantly lower carbon footprint; and energy-hungry information and communications technology companies that are leading the way on renewable energy. ',
                    _react2.default.createElement(
                      _components.Link,
                      { xstrong: true, to: _config2.default.routes.clean200, title: 'Clean200' },
                      'More',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  this.renderMoreLessHeadline(cl_asset, c2asset),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'bar-wrap' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'bar-wrap-inner' },
                      _react2.default.createElement(_reactChartjs.Bar, { data: barChartData, options: barChartOptions,
                        width: '300', height: '400' })
                    )
                  )
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement('br', null),
              _react2.default.createElement('br', null),
              _react2.default.createElement(_components.InlineSignup, null)
            )
          )
        ),
        _react2.default.createElement(_components.IyvScorecard, {
          fund: fund,
          shareClass: shareClass
        }),
        _react2.default.createElement(_components.FundShareTakeAction, { shareClass: shareClass, url: url })
      );
    }
  }]);
  return FundCleanEnergyInvestments;
}(_react.Component), _class2.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class) || _class);
exports.default = FundCleanEnergyInvestments;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FundCleanEnergyInvestments/FundCleanEnergyInvestments.js
// module id = 1403
// module chunks = 0